import { Fragment } from "react";
import { skillGroups, skillMarquee } from "../../data/skills";
import Marquee from "../ui/Marquee";
import Reveal from "../ui/Reveal";
import SectionHeading from "../ui/SectionHeading";

const Skills = () => (
  <section id="skills" className="grain relative overflow-hidden bg-ink">
    <div className="grid-lines absolute inset-0 opacity-40" />
    <div className="pointer-events-none absolute -left-32 top-1/4 h-[480px] w-[480px] rounded-full glow-moss" />

    {/* Tech marquee — the section opens with the toolkit in motion */}
    <div className="relative border-y border-cream/10 py-7">
      <Marquee
        items={skillMarquee.map(({ icon: Icon, name }) => (
          <Fragment key={name}>
            <Icon className="text-2xl text-mint/70" />
            <span className="font-display text-xl text-cream/60">{name}</span>
            <span className="ml-7 text-cream/15">/</span>
          </Fragment>
        ))}
        speed="animate-marquee-slow"
      />
    </div>

    <div className="section relative">
      <div className="shell">
        <SectionHeading
          index="03"
          eyebrow="Capabilities"
          title="A toolkit built for"
          accent="the whole stack."
          intro="Not a list of logos — these are the tools I reach for daily, and the parts of a product I can take responsibility for."
          tone="dark"
        />

        <div className="mt-16 grid gap-px overflow-hidden rounded-3xl border border-cream/10 bg-cream/10 md:grid-cols-3">
          {skillGroups.map((group, index) => (
            <Reveal key={group.title} delay={0.08 * index}>
              <div className="group h-full bg-ink p-8 transition-colors duration-500 hover:bg-forest sm:p-10">
                <div className="flex items-baseline gap-3">
                  <span className="font-mono text-[11px] text-sage/60">
                    0{index + 1}
                  </span>
                  <h3 className="font-display text-2xl text-cream">
                    {group.title}
                  </h3>
                </div>

                <p className="mt-3 text-sm leading-6 text-cream/45">
                  {group.caption}
                </p>

                <ul className="mt-8 space-y-3">
                  {group.items.map((item) => (
                    <li
                      key={item}
                      className="flex items-center gap-3 border-b border-cream/[0.07] pb-3 text-[15px] text-cream/75 transition-colors duration-300 last:border-0 hover:text-mint"
                    >
                      <span className="h-1 w-1 rounded-full bg-sage/70" />
                      {item}
                    </li>
                  ))}
                </ul>
              </div>
            </Reveal>
          ))}
        </div>

        {/* Current focus */}
        <Reveal delay={0.1}>
          <div className="relative mt-8 overflow-hidden rounded-3xl border border-mint/20 bg-gradient-to-br from-forest to-ink p-9 sm:p-14">
            <div className="absolute -right-20 -top-20 h-72 w-72 rounded-full glow-sage" />

            <div className="relative grid gap-8 lg:grid-cols-[0.9fr_1.1fr] lg:items-center">
              <div>
                <p className="eyebrow text-mint">Current focus</p>
                <h3 className="display mt-4 text-3xl leading-tight text-cream sm:text-[2.6rem]">
                  Full-stack SaaS platforms &amp; product experiences.
                </h3>
              </div>

              <p className="text-[1.02rem] leading-8 text-cream/55">
                Right now I’m deep in modern React and Laravel applications:
                scalable dashboard systems, AI-assisted platforms and the kind
                of polished, considered interfaces that make people trust a
                product before they’ve read a single word about it.
              </p>
            </div>
          </div>
        </Reveal>
      </div>
    </div>
  </section>
);

export default Skills;
